import { PRINT_TICKETS_GUEAST_FLOW_DATA } from '../PrintTickets';

const viewPdfScreenRegex = /^\/view-pdf\/[^\/]+$/;

const checkViewPdf = () => {
  const location = window.location;
  const pathname = location.pathname;
  const printTicketsGuestFlowDataInLocalStorage = localStorage.getItem(
    PRINT_TICKETS_GUEAST_FLOW_DATA,
  );

  if (printTicketsGuestFlowDataInLocalStorage) {
    sessionStorage.setItem(
      PRINT_TICKETS_GUEAST_FLOW_DATA,
      printTicketsGuestFlowDataInLocalStorage,
    );
    localStorage.removeItem(PRINT_TICKETS_GUEAST_FLOW_DATA);
  }

  const printTicketsGuestFlowDataInSessionStorage = sessionStorage.getItem(
    PRINT_TICKETS_GUEAST_FLOW_DATA,
  );

  const printTicketsGuestFlowData = !!printTicketsGuestFlowDataInSessionStorage
    ? JSON.parse(printTicketsGuestFlowDataInSessionStorage)
    : null;

  const accessViewPdfFromEmailLink =
    viewPdfScreenRegex.test(pathname) &&
    !!printTicketsGuestFlowData?.otp &&
    printTicketsGuestFlowData?.guest === '1';

  return {
    accessViewPdfFromEmailLink,
  };
};

export default checkViewPdf;
